export enum CompanyStatus {
    WORKING = '1001',
    DEMO = '1002',
    DISABLE = '1003',
}